// const clientDatabase = {
//   adminsss:
//   {
//     password: "123",
//     modules: ["temperature", "water", "air", "electrical", "configuration", "steam"]
//   },
//   // client2:
//   // {
//   //   password: "temp",
//   //   modules: ["temperature"]
//   // },
//   // client3:
//   // {
//   //   password: "client789",
//   //   modules: ["steam"]
//   // },
//   admin:
//   {
//     password: "123",
//     modules: ["temperature","configuration","electrical"]
//   },
// };

// const LoginForm = () => {
//   const [userData, setUserData] = useState({});
//   const [error, setError] = useState(null);
//   const [visible, setVisible] = useState(false);
//   const loggedIn = useSelector((state)=>state.user)
//       const { makeRequest } = useStoreUpdaterWithAPI();

//   //console.log(loggedIn)

//   const switchDarkMode = () => {
//     isdarkMode ? dispatch(handledarkMode(false)) : dispatch(handledarkMode(true));
//   };

//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [form] = Form.useForm();

//   const handleInputChange = (changedValues, allValues) => {
//     setUserData(allValues);
//   };

//   const handleReset = () => {
//     form.resetFields();
//   };
//     const handleForgetPasword = () => {
//     setVisible(true);
//   };
//     const onClose = () => {
//     setVisible(false);
//   }

//   const onSubmit = async () => {
//     try {
//       const { UserName, Password } = userData;
//       //console.log(userData)
//       const body={
//         emailIdOrUserName : UserName,
//         password: Password
//       }
//       //console.log(body)
//         makeRequest({
//               type: APIConstants.POST,
//               url: `${APIConstants.LOGIN_API}`,
//               body:body
//             }).then((res) => {
//               //console.log(res);
//               if (res&&res.success) {
//                 dispatch(isLoggedIn({ name: UserName }))
//                  message.success(` ${UserName} logged in successfully!`);
//                 navigate("/landing-page", { state: { modules: ["temperature","configuration","electrical"] } });
//                }else {
//                 setError("Invalid username or password");
//                }
//             });
//       // const client = clientDatabase[UserName];
//       // //console.log(client)
//       // if (client && client.password === Password) {
//       //   dispatch(isLoggedIn({ name: UserName }));
//       //   navigate("/landing-page", { state: { modules: client.modules } });
//       //   handleReset();
//       // } else {
//       //   setError("Invalid username or password");
//       // }
//     } catch (err) {
//       //console.error("Error in login:", err);
//     }
//   };

//   const mode = useSelector((state) => state.darkMode);

//   const { isdarkMode } = mode;
//   // //console.log(isdarkMode)

//   return (
//     <div className={`flex justify-center bg-white items-center md:h-screen md:flex-row dark ${isdarkMode ? 'darkmode' : 'whitemode'} relative`}

// >
//   <div className="h-40 w-40 rounded-full absolute bg-green-400 top-0 left-12 "/>
//   <div className="h-20 w-20 rounded-full shadow-2xl absolute bg-green-400 top-10 left-72"/>
//   <div className="h-20 w-20 rounded-full shadow-2xl absolute bg-green-400 top-4 left-[800px]"/>
//   <div className="h-40 w-40 rounded-full absolute bg-green-400 -bottom-10 left-80 "/>
//   <div className="w-[90vw] shadow-xl  flex border  relative h-[95vh] overflow-hidden rounded-3xl bg-white/35"
//   //  style={{ backgroundImage: `url(${bgImage})` }}
//    >
//       <div className={` w-1/2  p-10  gap-5 flex flex-col items-center justify-center relative `}>
//       {/* <div className="h-10 w-10 rounded-full absolute bg-purple-400 -top-5 left-0 "/> */}
//         <img
//           src={loginImg}
//           alt="Background"
//           className="h-[200px] w-full pl-10"
//         />
//         <div
//    className={`w-full text-4xl font-bold font-serif tracking-wide  text-center
//     ${isdarkMode ? 'text-green-300' : 'text-green-400'}
//    `}
// >
//   Welcome to the Expert Trax
//   <br />
//   Energy Management Software
//   <br />
//   <div className="text-lg">
//   • One stop solution to energy Analytics
//   </div>
//   {/* <br /> */}
//   <div className="text-lg">
//   •Realtime Analysis
//   </div>

// </div>

//       </div>
//       <div className={`w-1/2 lg:w-2/4 bg-green-500 flex justify-center items-center min-h-screen dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}>
//       <div className="form-container flex flex-col justify-center items-center  md:h-[80vh] h-[70vh] w-[40vw] md:w-[30vw] rounded-xl bg-white px-10 bg-white/55">
//           <div className="mb-2 ">
//             <div className="text-white font-semibold text-center ">
//               <p className="text-[50px] mb-0">Welcome Experts</p>
//               <p className="mb-5 text-white text-[40px]">Login</p>
//             </div>

//             {/* <p className={`text-zinc-500 mt-0 text-md tracking-wide font-semibold text-center ${isdarkMode ? 'darkfont' : 'whitemode'} `}>
//              Energy Management Software
//             </p> */}
//           </div>
//           <ConfigProvider
//             theme={{
//               token: {
//                 colorBgContainer: isdarkMode ? "#292c35" : "#f6ffed",
//                 colorTextBase: isdarkMode ? "#fff" : "#000",
//               },
//             }}
//           >
//             <Form
//               name="normal_login"
//               className="login-form"
//               initialValues={{
//                 remember: true,
//               }}
//               onFinish={onSubmit}
//               form={form}
//               onValuesChange={handleInputChange}
//             >
//               <Form.Item
//                 name="UserName"
//                 className={`login-input ${isdarkMode ? "login-input" : "#f6ffed"} text-white font-semibold text-lg mb-9`}

//                 rules={[
//                   {
//                     required: true,
//                     message: "Please input your Username!",
//                   },
//                 ]}
//               >
//                 <Input
//                   placeholder="Username"
//                   // className="p-3 rounded-full login-input"
//                   // prefix={<UserOutlined className="site-form-item-icon pl-2" />}
//                    className="custom-login-input p-3  rounded-lg bg-transparent border border-gray-500  focus:bg-transparent focus:shadow-none !bg-transparent w-[400px] border-2 border-white text-white font-bold text-lg hover:scale-105"
//                   prefix={
//                     <UserOutlined className="site-form-item-icon pl-2 text-white" />
//                   }

//                 />
//               </Form.Item>

//               <Form.Item
//                 name="Password"
//                 className="login-input text-white font-semibold text-lg mb-9 font-bold"
//                 rules={[
//                   {
//                     required: true,
//                     message: "Please input your Password!",
//                   },
//                 ]}
//               >
//                 <Input
//  className="custom-login-input p-3  rounded-lg bg-transparent border border-gray-500  focus:bg-transparent focus:shadow-none !bg-transparent border-white border-2 w-[400px] text-white font-bold text-lg hover:scale-105"
//                   prefix={
//                     <UserOutlined className="site-form-item-icon pl-2 text-white" />
//                   }                  type="password"
//                   placeholder="Password "
//                   // className="p-3 w-[300px] rounded-full"
//                 />
//               </Form.Item>
//               {error && (
//                 <div className="text-center text-red-400 font-semibold text-sm">
//                   {error}
//                 </div>
//               )}
//               <Form.Item>
//                 <Button
//                   // type="primary"
//                   htmlType="submit"
//                   className={`login-form-button hover:border-0 hover:scale-105  border-white text-white bg-green-200 w-full shadow-2xl border  rounded-xl h-11 text-xl tracking-wide ${isdarkMode ? 'loginbtn' : 'whitemode'}`}
//                 >
//                   LOGIN
//                 </Button>
//               </Form.Item>
//             </Form>
//           </ConfigProvider>
//            <div className=" justify-between flex text-center mt-0 w-[400px]">
//               <span
//                 className={`text-red-400  font-bold text-xl text-sm cursor-pointer  ${isdarkMode ? 'darkfont' : 'whitemode'}`}
//                 onClick={handleForgetPasword}
//               >
//                 Forget Password?
//               </span>
//               {/* <span
//                 className={` font-semibold text-sm cursor-pointer  ${isdarkMode ? 'darkfont' : 'whitemode'}`}
//                 onClick={() => navigate("/sign-up")}>
//                 Sign Up
//               </span> */}
//             </div>
//                     <EmailPasswordReset visible={visible} onClose={onClose} />

//         </div>
//       </div>
//   </div>
//     </div>
//   );
// };

// export default LoginForm;

// import { useEffect, useState } from "react";
// import loginImage from "../../Assets/Images/login2.png";
// import minnotra_logo from "../../Assets/Images/logo2.png";
// import loginImg from "../../Assets/Images/LoginLogo.png";
// import bgImage from "../../Assets/Images/bg.svg";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { isLoggedIn } from "../../Utils/UserSlice";
// import { handledarkMode } from "../Elements/DarkModeAction";
// import EmailOtp from "./EmailOTP";
// import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
// import { APIConstants } from "../../Common/APIConstants";
// import EmailPasswordReset from "./EmailOTP";

// const clientDatabase = {
//   adminsss: {
//     password: "123",
//     modules: [
//       "temperature",
//       "water",
//       "air",
//       "electrical",
//       "configuration",
//       "steam",
//     ],
//   },
//   // client2:
//   // {
//   //   password: "temp",
//   //   modules: ["temperature"]
//   // },
//   // client3:
//   // {
//   //   password: "client789",
//   //   modules: ["steam"]
//   // },
//   admin: {
//     password: "123",
//     modules: ["temperature", "configuration", "electrical"],
//   },
// };

// import React from "react";
// import {
//   Input,
//   Button,
//   Card,
//   Checkbox,
//   Typography,
//   ConfigProvider,
//   Form,
//   message,
//   Carousel,
//   Slider,
// } from "antd";
// import {
//   UserOutlined,
//   LockOutlined,
//   DollarOutlined,
//   BarChartOutlined,
//   ThunderboltOutlined,
//   CheckCircleOutlined,
//   SyncOutlined,
//   RiseOutlined,
//   FallOutlined,
// } from "@ant-design/icons";

// const { Title, Text } = Typography;

// // import { DollarOutlined, RiseOutlined, FallOutlined } from "@ant-design/icons";

// export default function LoginPage() {
//   const mode = useSelector((state) => state.darkMode);

//   const { isdarkMode } = mode;
//   // //console.log(isdarkMode)
//   const [userData, setUserData] = useState({});
//   const [error, setError] = useState(null);
//   const [visible, setVisible] = useState(false);
//   const loggedIn = useSelector((state) => state.user);
//   const { makeRequest } = useStoreUpdaterWithAPI();

//   //console.log(loggedIn);

//   const switchDarkMode = () => {
//     isdarkMode
//       ? dispatch(handledarkMode(false))
//       : dispatch(handledarkMode(true));
//   };

//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [form] = Form.useForm();

//   const handleInputChange = (changedValues, allValues) => {
//     setUserData(allValues);
//   };

//   const handleReset = () => {
//     form.resetFields();
//   };
//   const handleForgetPasword = () => {
//     setVisible(true);
//   };
//   const onClose = () => {
//     setVisible(false);
//   };

//   const onSubmit = async () => {
//     try {
//       const { UserName, Password } = userData;
//       //console.log(userData);
//       const body = {
//         emailIdOrUserName: UserName,
//         password: Password,
//       };
//       //console.log(body);
//       makeRequest({
//         type: APIConstants.POST,
//         url: `${APIConstants.LOGIN_API}`,
//         body: body,
//       }).then((res) => {
//         //console.log(res);
//         if (res && res.success) {
//           dispatch(isLoggedIn({ name: UserName }));
//           message.success(` ${UserName} logged in successfully!`);
//           navigate("/landing-page", {
//             state: { modules: ["temperature", "configuration", "electrical"] },
//           });
//         } else {
//           setError("Invalid username or password");
//         }
//       });
//       // const client = clientDatabase[UserName];
//       // //console.log(client)
//       // if (client && client.password === Password) {
//       //   dispatch(isLoggedIn({ name: UserName }));
//       //   navigate("/landing-page", { state: { modules: client.modules } });
//       //   handleReset();
//       // } else {
//       //   setError("Invalid username or password");
//       // }
//     } catch (err) {
//       //console.error("Error in login:", err);
//     }
//   };
//   const cardData = [
//     {
//       icon: (
//         <DollarOutlined className="text-3xl text-white bg-sky-400  p-2 rounded-xl " />
//       ),
//       value: "$2.3M",
//       label: "Savings",
//       color: "sky-400",
//       range:"55"
//     },
//     {
//       icon: (
//         <RiseOutlined className="text-3xl  text-white bg-green-400 p-2 rounded-xl" />
//       ),
//       value: "$8.7M",
//       label: "Revenue",
//       color: "green-400",
//       range:"25"
//     },
//     {
//       icon: (
//         <FallOutlined className="text-3xl text-white bg-red-400 p-2 rounded-xl" />
//       ),
//       value: "$500K",
//       label: "Loss Prevention",
//       color: "red-400",
//       range:"95"
//     },
//   ];
//   const tailwindColorMap = {
//   'sky-400': '#38bdf8',
//   'green-400': '#4ade80',
//   'red-400': '#f87171',
// };
// const [activeIndex, setActiveIndex] = useState(0);
//   const [sliderValue, setSliderValue] = useState(0);

//   // Animate slider when activeIndex changes
//   useEffect(() => {
//     let start = 0;
//     const target = cardData[activeIndex].range;
//     const step = () => {
//       start += 1;
//       setSliderValue(start);
//       if (start < target) {
//         requestAnimationFrame(step);
//       }
//     };
//     setSliderValue(0);
//     requestAnimationFrame(step);
//   }, [activeIndex]);

//   return (
//     <div className="flex h-screen bg-gradient-to-b from-[#0f4c75] via-[#1b7344] to-[#63ff94]  p-6 gap-8">
//       {/* Left Section */}
//       <div className="w-[50%] flex justify-center items-center">
//         <div className="flex flex-col justify-center items-center flex-1 space-y-6  w-full ">
//           <div className="text-center">
//             <Title level={2} className="!text-white">
//               Minnotra EMS
//             </Title>
//             <Text className="!text-blue-300 text-md w-56">
//               Advanced Manufacturing Intelligence • Real-time Monitoring •
//               Predictive Analytics
//             </Text>
//           </div>

//           {/* Savings Card */}
//          <Card
//       bordered={false}
//       className="bg-white/5 text-center text-white w-[450px] rounded-xl shadow-lg border-[0.1px] border-gray-500 transform transition-transform duration-300 hover:scale-105 cursor-pointer"
//     >
//       <Carousel
//         autoplay
//         dots={false}
//         effect="scrollx"
//         beforeChange={(from, to) => setActiveIndex(to)}
//         className=""
//       >
//         {cardData.map((item, idx) => (
//           <div key={idx} className="flex flex-col items-center overflow-hidden ">
//             <div className="flex justify-center items-center">
//             <span className={`bg-${item.color} w-fit rounded-full flex items-center justify-center`}>
//               {item.icon}
//             </span>
//             </div>
//             <Title level={2} className="!text-white m-0">
//               {item.value}
//             </Title>
//             <Text className="!text-gray-300 text-lg">{item.label}</Text>

//             <Slider
//               min={0}
//               max={100}
//               value={idx === activeIndex ? sliderValue : 0}
//               trackStyle={{
//                 backgroundColor: tailwindColorMap[item.color] || "#3b82f6",
//                 height: 14,
//                 borderRadius:'30px',
//                 transition: "width 0.1s linear",
//               }}
//               handleStyle={{
//                 backgroundColor: tailwindColorMap[item.color] || "#3b82f6",
//                 borderColor: tailwindColorMap[item.color] || "#3b82f6",
//                 borderRadius:'30px',
//                 marginTop: 4,
//                 display:'none'
//               }}
//               railStyle={{
//                 backgroundColor: "#374151",
//                 height: 14,
//                 borderRadius:'30px',
//               }}
//               className="rounded-full w-full"
//             />
//           </div>
//         ))}
//       </Carousel>
//     </Card>

//           {/* Feature Cards */}
//           <div className="grid grid-cols-2 gap-4 mt-4 w-[450px]">
//             <Card className="bg-white/10 text-white text-center rounded-xl shadow-md border-[0.1px] border-gray-400 transform transition-transform duration-300 hover:scale-105 cursor-pointer">
//               <BarChartOutlined /> Live Analytics
//             </Card>
//             <Card className="bg-white/10 text-white text-center rounded-xl shadow-md border-[0.1px] border-gray-400 transform transition-transform duration-300 hover:scale-105 cursor-pointer">
//               <ThunderboltOutlined /> Predictive AI
//             </Card>
//             <Card className="bg-white/10 text-white text-center rounded-xl shadow-md border-[0.1px] border-gray-400 transform transition-transform duration-300 hover:scale-105 cursor-pointer">
//               <CheckCircleOutlined /> Quality Control
//             </Card>
//             <Card className="bg-white/10 text-white text-center rounded-xl shadow-md border-[0.1px] border-gray-400 transform transition-transform duration-300 hover:scale-105 cursor-pointer">
//               <SyncOutlined /> Optimization
//             </Card>
//           </div>
//         </div>
//       </div>

//       {/* Right Section */}
//       <div className="w-[50%]   p-6 flex justify-center items-center">
//         <Card
//           className="w-[450px] flex justify-center bg-white/10 backdrop-blur-lg shadow-xl
//        rounded-3xl h-[70vh] border-violet-500 border-t-8 border-t-blue-600"
//         >
//           <ConfigProvider
//             theme={{
//               token: {
//                 colorBgContainer: isdarkMode ? "#292c35" : "#f6ffed",
//                 colorTextBase: isdarkMode ? "#fff" : "#000",
//               },
//             }}
//           >
//             <div className="text-white text-center mb-5">
//               <h2 className="text-3xl font-semibold">Welcome Back</h2>
//               <div className="text-gray-300">Sign in to your dashboard</div>
//             </div>
//             <Form
//               name="normal_login"
//               className="login-form w-[400px]"
//               initialValues={{
//                 remember: true,
//               }}
//               onFinish={onSubmit}
//               form={form}
//               onValuesChange={handleInputChange}
//             >
//               <Form.Item
//                 name="UserName"
//                 className={`login-input ${isdarkMode ? "login-input" : "#f6ffed"}`}
//                 rules={[
//                   {
//                     required: true,
//                     message: "Please input your Username!",
//                   },
//                 ]}
//               >
//                 <Input
//                   placeholder="Username"
//                   className="custom-login-input p-3  rounded-lg bg-transparent border border-gray-500  focus:bg-transparent focus:shadow-none !bg-transparent"
//                   prefix={
//                     <UserOutlined className="site-form-item-icon pl-2 text-white" />
//                   }
//                 />
//               </Form.Item>

//               <Form.Item
//                 name="Password"
//                 className="login-input"
//                 rules={[
//                   {
//                     required: true,
//                     message: "Please input your Password!",
//                   },
//                 ]}
//               >
//                 <Input
//                   prefix={
//                     <LockOutlined className="site-form-item-icon pl-2 text-white" />
//                   }
//                   type="password"
//                   placeholder="Password"
//                   className="custom-login-input p-3 rounded-lg bg-transparent border border-gray-500  focus:bg-transparent focus:shadow-none !bg-transparent"
//                 />
//               </Form.Item>
//               {error && (
//                 <div className="text-center text-red-400 font-semibold text-sm">
//                   {error}
//                 </div>
//               )}
//               <Form.Item>
//                 <Button
//                   type="primary"
//                   htmlType="submit"
//                   // className={`login-form-button w-full border-0 rounded-full h-11 text-xl tracking-wide ${isdarkMode ? 'loginbtn' : 'whitemode'}`}
//                   size="large"
//                   block
//                   className="mt-4 h-10 rounded-lg border-none"
//                   style={{
//                     background: "linear-gradient(to right, #36d1dc, #5b86e5)",
//                   }}
//                 >
//                   LOGIN
//                 </Button>
//               </Form.Item>
//             </Form>
//             <div className=" justify-between flex w-full text-center mt-0">
//               {/* <span
//                 className={`text-red-400 font-semibold text-sm cursor-pointer  ${isdarkMode ? 'darkfont' : 'whitemode'}`}
//                 onClick={handleForgetPasword}
//               >
//                 Forget Password?
//               </span> */}
//               {/* <span
//                 className={` font-semibold text-sm cursor-pointer  ${isdarkMode ? 'darkfont' : 'whitemode'}`}
//                 onClick={() => navigate("/sign-up")}>
//                 Sign Up
//               </span> */}
//             </div>
//             <EmailPasswordReset visible={visible} onClose={onClose} />

//             <div className="flex justify-between items-center mt-2">
//               <Checkbox className="text-white">Remember me</Checkbox>
//               <div
//                 className="text-sky-400 cursor-pointer"
//                 onClick={handleForgetPasword}
//               >
//                 Forgot password?
//               </div>
//             </div>
//           </ConfigProvider>
//         </Card>
//       </div>
//     </div>
//   );
// }

import loginImage from "../../Assets/Images/login2.png";
import expertLogo from "../../Assets/Images/SmallLogo.png";
import loginImg from "../../Assets/Images/LoginLogo.png";
import bgImage from "../../Assets/Images/bg.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  ImageSlice,
  isLoggedIn,
  logOut,
  Userscreen,
} from "../../Utils/UserSlice";
import { handledarkMode } from "../Elements/DarkModeAction";
import EmailOtp from "./EmailOTP";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../Common/APIConstants";
import EmailPasswordReset from "./EmailOTP";
import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Input,
  Button,
  Checkbox,
  message,
  Row,
  Col,
  Statistic,
  Progress,
  Image,
} from "antd";
import {
  UserOutlined,
  LockOutlined,
  EnvironmentOutlined,
  ThunderboltOutlined,
  DollarOutlined,
  RiseOutlined,
  SafetyOutlined,
  MonitorOutlined,
  SettingOutlined,
  BellOutlined,
  CloudOutlined,
  RobotOutlined,
  EyeOutlined,
  TrophyOutlined,
  MailOutlined,
} from "@ant-design/icons";
// import { useAuth } from '../../contexts/AuthContext';
import ReactECharts from "echarts-for-react";

const LoginForm2 = () => {
  const [loading, setLoading] = useState(false);
const [client, setClient] = useState(null);

  // const { login } = useAuth();

  // Animated metrics state
  const [metrics, setMetrics] = useState({
    energySaved: 0,
    co2Reduction: 0,
    costSavings: 0,
    efficiency: 0,
  });

  // Animate metrics on component mount
  useEffect(() => {
    const animateMetrics = () => {
      const targets = {
        energySaved: 1245,
        co2Reduction: 920,
        costSavings: 32540,
        efficiency: 18,
      };

      const duration = 2000; // 2 seconds
      const steps = 60;
      const stepDuration = duration / steps;

      let currentStep = 0;
      const interval = setInterval(() => {
        currentStep++;
        const progress = currentStep / steps;
        const easeOutQuart = 1 - Math.pow(1 - progress, 4);

        setMetrics({
          energySaved: Math.round(targets.energySaved * easeOutQuart),
          co2Reduction: Math.round(targets.co2Reduction * easeOutQuart),
          costSavings: Math.round(targets.costSavings * easeOutQuart),
          efficiency: Math.round(targets.efficiency * easeOutQuart),
        });

        if (currentStep >= steps) {
          clearInterval(interval);
        }
      }, stepDuration);
    };

    const timer = setTimeout(animateMetrics, 500);
    return () => clearTimeout(timer);
  }, []);

  const [userData, setUserData] = useState({});
  const [error, setError] = useState(null);
  const [visible, setVisible] = useState(false);
  const { makeRequest } = useStoreUpdaterWithAPI();

  const [logo, setLogo] = useState(null);
  const [background, setBackground] = useState(null);
  const loggedIn = useSelector((state) => state.user);
  console.log(loggedIn);
  const getLicenseDetails = () => {
  const url = `${APIConstants.GET_LICENSE_DETAILS}/1`;

  makeRequest({
    type: APIConstants.GET,
    url
  }).then((res) => {
    if (res) {
      setClient(res[0]); 
    }
  });
};

  // const getLicenseDetails = () => {
  //   alert("get")
  //   const url = `${APIConstants.GET_LICENSE_DETAILS}/1`;
  //   makeRequest({
  //     type: APIConstants.GET,
  //     url: url,
  //   }).then((res) => {
  //     console.log(res);
  //     if (res) {
  //       console.log(res)
  //       setClient(res);
  //     }
  //   });
  // };
  const getImages = () => {
    // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
    const url = `${APIConstants.ELECTRICAL_GET_LOGO_IMAGE}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      console.log(res);
      if (res) {
        setLogo(res?.logo ? `data:image/png;base64,${res?.logo}` : null);
        setBackground(
          res?.backGroundImage
            ? `data:image/png;base64,${res?.backGroundImage}`
            : null
        );
        dispatch(ImageSlice(res));
      }
    });
  };
  useEffect(() => {
    getImages();
    getLicenseDetails();
  }, []);
  console.log(client,"clint");
//  useEffect(() => {
//   if (client?.ClientName != null&&client?.NoOfMeters != null){
//     return
//   }else{

//        navigate("/license-form");
//   } ;

//   // if (Array.isArray(client) && client.length === 0) {
//     // navigate("/license-form");
//   // }

// }, [client]);



  const switchDarkMode = () => {
    isdarkMode
      ? dispatch(handledarkMode(false))
      : dispatch(handledarkMode(true));
  };
  const handleLogout = () => {
    dispatch(logOut());
  };
  useEffect(() => {
    handleLogout();
  }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const handleInputChange = (changedValues, allValues) => {
    setUserData(allValues);
  };

  const handleReset = () => {
    form.resetFields();
  };
  const handleForgetPasword = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };

  const validateScreen = (formValues) => {
    //console.log(formValues);

    const url = `${APIConstants.VALIDATE_SCREEN_API}?RoleId=${formValues.roleId}`;

    //console.log(url);
    // //console.log(body);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body: body,
    }).then((res) => {
      console.log(res);
      dispatch(Userscreen(res));
      // handleNotification("Successfully Deleted", "success");
    });
  };


  const isSubscriptionValid = (startDate, endDate) => {
  // Extract YYYY-MM-DD only
  const today = new Date().toISOString().split("T")[0];
  const start = startDate.split("T")[0];
  const end = endDate.split("T")[0];

  return today >= start && today <= end;
};

const onSubmit = async () => {
  try {
    const { email, password } = userData;
      //console.log(userData);
      const body = {
        emailIdOrUserName: email,
        password: password,
      };
      //console.log(body);
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.LOGIN_API}?username=${email}&password=${password}`,
        // body:body
    }).then((res) => {
      console.log(res);

      if (res && res.message === "Login Successful") {
        const isValidSubscription = isSubscriptionValid(
          client?.StartDate,
          client?.EndDate
        );

        if (!isValidSubscription) {
          message.error("Subscription expired, contact Minnotra");
          return; 
        }

        validateScreen(res);
        dispatch(isLoggedIn({ name: email, roleId: res.roleId }));
          message.success(` ${email} logged in successfully!`);
          client.clID&&navigate("/electrical-dashboard", {
          state: { modules: ["temperature", "configuration", "electrical"] },
        });

      } else {
        message.error(res.message);
        setError("Invalid username or password");
      }
    });

  } catch (err) {
    console.error("Error in login:", err);
  }
};


  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  // //console.log(isdarkMode)

  // Mini chart for energy trends
  const miniChartOption = {
    backgroundColor: "transparent",
    grid: { top: 5, right: 5, bottom: 5, left: 5 },
    xAxis: {
      type: "category",
      show: false,
      data: Array.from({ length: 7 }, (_, i) => `Day ${i + 1}`),
    },
    yAxis: { type: "value", show: false },
    series: [
      {
        type: "line",
        data: [65, 78, 82, 88, 95, 102, 108],
        smooth: true,
        lineStyle: { color: "#10b981", width: 2 },
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: "rgba(16, 185, 129, 0.3)" },
              { offset: 1, color: "rgba(16, 185, 129, 0.05)" },
            ],
          },
        },
        symbol: "none",
      },
    ],
  };
  const features = [
    {
      icon: <RobotOutlined className="text-green-400" />,
      title: "Auto Load Balancing",
      description: "Smart distribution during peak demand",
    },
    {
      icon: <BellOutlined className="text-orange-400" />,
      title: "Predictive Maintenance",
      description: "AI-powered equipment health alerts",
    },
    {
      icon: <CloudOutlined className="text-blue-400" />,
      title: "Smart Scheduling",
      description: "Optimize heavy machinery operations",
    },
    {
      icon: <SafetyOutlined className="text-purple-400" />,
      title: "Remote Configuration",
      description: "Control meters & gateways remotely",
    },
  ];

  console.log(logo);
  console.log(background);
useEffect(() => {
  if (!client) return;

  const isValidClient =
    client.clID === 1 &&
    client.ClientName &&
    Number(client.NoOfMeters) > 0;

  if (!isValidClient) {
    navigate("/license-form");
  }
}, [client, navigate]);



  return (
    <>
      <style jsx>{`
        /* Floating Animation */
        @keyframes float {
          0%,
          100% {
            transform: translateY(0px) rotate(0deg);
          }
          33% {
            transform: translateY(-30px) rotate(120deg);
          }
          66% {
            transform: translateY(-20px) rotate(240deg);
          }
        }

        @keyframes floatReverse {
          0%,
          100% {
            transform: translateY(0px) rotate(0deg);
          }
          33% {
            transform: translateY(20px) rotate(-120deg);
          }
          66% {
            transform: translateY(-15px) rotate(-240deg);
          }
        }

        @keyframes pulse {
          0%,
          100% {
            opacity: 0.4;
            transform: scale(1);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.1);
          }
        }

        @keyframes wave {
          0% {
            transform: translateX(-100px) translateY(0px);
          }
          50% {
            transform: translateX(100px) translateY(-20px);
          }
          100% {
            transform: translateX(-100px) translateY(0px);
          }
        }

        @keyframes drift {
          0%,
          100% {
            transform: translateX(0px) translateY(0px) rotate(0deg);
          }
          25% {
            transform: translateX(40px) translateY(-30px) rotate(90deg);
          }
          50% {
            transform: translateX(-20px) translateY(-50px) rotate(180deg);
          }
          75% {
            transform: translateX(-40px) translateY(-20px) rotate(270deg);
          }
        }

        @keyframes morphing {
          0%,
          100% {
            border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
            transform: scale(1) rotate(0deg);
          }
          25% {
            border-radius: 30% 60% 70% 40% / 50% 60% 30% 60%;
            transform: scale(1.1) rotate(90deg);
          }
          50% {
            border-radius: 50% 30% 60% 70% / 40% 70% 50% 30%;
            transform: scale(0.9) rotate(180deg);
          }
          75% {
            border-radius: 70% 50% 40% 60% / 30% 40% 60% 50%;
            transform: scale(1.05) rotate(270deg);
          }
        }

        @keyframes dots-wave {
          0%,
          40%,
          100% {
            transform: scaleY(0.4);
          }
          20% {
            transform: scaleY(1);
          }
        }

        .floating {
          animation: float 6s ease-in-out infinite;
        }

        .floating-reverse {
          animation: floatReverse 8s ease-in-out infinite;
        }

        .pulse-animation {
          animation: pulse 4s ease-in-out infinite;
        }

        .wave-animation {
          animation: wave 12s ease-in-out infinite;
        }

        .drift-animation {
          animation: drift 15s ease-in-out infinite;
        }

        .morphing-animation {
          animation: morphing 10s ease-in-out infinite;
        }

        .glass-effect {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .dots-container {
          position: absolute;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }

        .dot {
          position: absolute;
          width: 4px;
          height: 4px;
          background: rgba(16, 185, 129, 0.6);
          border-radius: 50%;
          animation: dots-wave 2s ease-in-out infinite;
        }

        .dot:nth-child(1) {
          left: 10%;
          animation-delay: 0s;
        }
        .dot:nth-child(2) {
          left: 20%;
          animation-delay: 0.2s;
        }
        .dot:nth-child(3) {
          left: 30%;
          animation-delay: 0.4s;
        }
        .dot:nth-child(4) {
          left: 40%;
          animation-delay: 0.6s;
        }
        .dot:nth-child(5) {
          left: 50%;
          animation-delay: 0.8s;
        }
        .dot:nth-child(6) {
          left: 60%;
          animation-delay: 1s;
        }
        .dot:nth-child(7) {
          left: 70%;
          animation-delay: 1.2s;
        }
        .dot:nth-child(8) {
          left: 80%;
          animation-delay: 1.4s;
        }
        .dot:nth-child(9) {
          left: 90%;
          animation-delay: 1.6s;
        }

        .gradient-text {
          background: linear-gradient(135deg, #10b981, #059669, #047857);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .glass-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 25px 45px rgba(0, 0, 0, 0.1);
        }

        .glass-green {
          background: rgba(16, 185, 129, 0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(16, 185, 129, 0.2);
        }

        .hover-lift {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .hover-lift:hover {
          transform: translateY(-5px);
          box-shadow: 0 35px 60px rgba(0, 0, 0, 0.15);
        }

        .pulse-glow {
          animation: pulse-glow 2s ease-in-out infinite alternate;
        }

        @keyframes pulse-glow {
          from {
            box-shadow: 0 0 20px rgba(16, 185, 129, 0.4);
          }
          to {
            box-shadow: 0 0 30px rgba(16, 185, 129, 0.8);
          }
        }

        .count-up {
          animation: countUp 0.8s ease-out forwards;
        }

        @keyframes countUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .metric-card {
          transition: all 0.3s ease;
        }

        .metric-card:hover {
          transform: translateY(-3px);
          background: rgba(255, 255, 255, 0.15) !important;
        }
      `}</style>

      <div className="min-h-screen relative overflow-y-scroll overflow-x-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-green-50 via-emerald-100 to-teal-200"></div>
          <div className="absolute inset-0 bg-gradient-to-tr from-green-900/5 via-transparent to-emerald-900/10"></div>

          <div className="absolute top-20 left-10 w-32 h-32 bg-gradient-to-br from-green-400/30 to-emerald-500/30 rounded-full blur-xl floating"></div>
          <div
            className="absolute top-40 right-20 w-24 h-24 bg-gradient-to-br from-teal-400/25 to-green-500/25 blur-lg floating-reverse"
            style={{ animationDelay: "2s" }}
          ></div>
          <div
            className="absolute bottom-32 left-1/4 w-28 h-28 bg-gradient-to-br from-emerald-400/20 to-green-600/20 rounded-full blur-2xl drift-animation"
            style={{ animationDelay: "4s" }}
          ></div>

          <div
            className="absolute top-1/3 left-1/3 w-16 h-16 bg-gradient-to-br from-green-300/40 to-emerald-400/40 rounded-lg pulse-animation"
            style={{ animationDelay: "1s" }}
          ></div>
          <div
            className="absolute bottom-1/3 right-1/3 w-20 h-20 bg-gradient-to-br from-teal-300/35 to-green-400/35 morphing-animation"
            style={{ animationDelay: "3s" }}
          ></div>

          <div
            className="absolute top-1/4 right-1/4 w-12 h-12 bg-gradient-to-br from-emerald-300/50 to-green-500/50 transform rotate-45 floating"
            style={{ animationDelay: "5s" }}
          ></div>
          <div
            className="absolute bottom-1/4 left-1/5 w-10 h-10 bg-gradient-to-br from-green-400/45 to-teal-500/45 rounded-full pulse-animation"
            style={{ animationDelay: "2.5s" }}
          ></div>

          <div
            className="absolute top-3/4 left-3/4 w-8 h-8 bg-gradient-to-br from-green-200/60 to-emerald-300/60 rounded-full floating-reverse"
            style={{ animationDelay: "6s" }}
          ></div>
          <div
            className="absolute top-1/6 left-3/5 w-6 h-6 bg-gradient-to-br from-teal-300/50 to-green-300/50 transform rotate-12 pulse-animation"
            style={{ animationDelay: "4.5s" }}
          ></div>

          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-transparent via-green-300/30 to-transparent wave-animation"></div>
          <div
            className="absolute bottom-0 left-0 w-full h-2 bg-gradient-to-r from-transparent via-emerald-300/30 to-transparent wave-animation"
            style={{ animationDelay: "6s" }}
          ></div>

          <div className="dots-container">
            <div className="absolute top-1/4 left-1/2">
              {[...Array(9)].map((_, i) => (
                <div
                  key={i}
                  className="dot"
                  style={{ top: `${i * 20}px` }}
                ></div>
              ))}
            </div>
            <div className="absolute top-1/2 left-1/4">
              {[...Array(9)].map((_, i) => (
                <div
                  key={i}
                  className="dot"
                  style={{
                    top: `${i * 15}px`,
                    animationDelay: `${i * 0.1 + 1}s`,
                  }}
                ></div>
              ))}
            </div>
            <div className="absolute top-1/3 right-1/4">
              {[...Array(9)].map((_, i) => (
                <div
                  key={i}
                  className="dot"
                  style={{
                    top: `${i * 25}px`,
                    animationDelay: `${i * 0.1 + 2}s`,
                  }}
                ></div>
              ))}
            </div>
          </div>

          <div className="absolute top-1/5 left-1/6 w-14 h-14 border-2 border-green-300/40 rounded-full floating"></div>
          <div
            className="absolute top-2/3 right-1/6 w-18 h-18 border-2 border-emerald-300/35 rounded-full floating-reverse"
            style={{ animationDelay: "3s" }}
          ></div>
          <div
            className="absolute bottom-1/5 left-2/3 w-12 h-12 border-2 border-teal-300/45 rounded-full drift-animation"
            style={{ animationDelay: "7s" }}
          ></div>

          <div
            className="absolute top-1/2 left-1/8 w-24 h-24 bg-gradient-to-br from-green-200/25 to-emerald-300/25 morphing-animation"
            style={{ animationDelay: "8s" }}
          ></div>
          <div
            className="absolute bottom-1/3 right-1/8 w-20 h-20 bg-gradient-to-br from-teal-200/30 to-green-300/30 morphing-animation"
            style={{ animationDelay: "4s" }}
          ></div>
        </div>

        {/* Main Content */}
        <div className="relative z-10 min-h-screen">
          <Row className="md:min-h-screen h-auto mt-20 md:my-0">
            {/* Left Side - Login Form */}
            <Col
              xs={24}
              lg={12}
              className="flex items-center justify-center p-8 py-0"
            >
              <div className="w-full max-w-md">
                {/* Logo and Title */}
                <div className="text-center mb-0">
                  <div className="inline-flex items-center justify-center w-16 h-16 glass-green rounded-3xl mb-2 pulse-glow">
                    <div className="w-12 h-12 bg-gradient-to-br from-green-400 to-emerald-600 rounded-2xl flex items-center justify-center">
                      <img src={expertLogo} className="h-8 w-10" />
                      {/* <EnvironmentOutlined className="text-2xl text-white" /> */}
                    </div>
                  </div>
                  <h1 className="text-3xl font-bold gradient-text mb-0">
                    Expert Trax EMS
                  </h1>
                  <p className="text-green-700 text-lg font-medium">
                    Smart Energy. Smarter Savings.
                  </p>
                  <div className="flex items-center justify-center space-x-3 mt-0">
                    <div className="px-4 py-2 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full shadow-lg">
                      <span className="text-white text-sm font-bold flex items-center">
                        <RobotOutlined className="mr-2" /> Powered by Minnotra
                        Energy
                      </span>
                    </div>
                  </div>
                </div>

                {/* Login Card */}
                <Card className="glass-card border-0 shadow-2xl hover-lift rounded-3xl mt-1">
                  <div className="p-8 py-0">
                    <div className="text-center mb-1">
                      <h2 className="text-2xl font-bold text-green-800 mb-2">
                        Welcome{" "}
                      </h2>
                      <p className="text-green-600 text-lg">
                        Sign in to your Expert Trax dashboard
                      </p>
                    </div>

                    <Form
                      name="login"
                      onFinish={onSubmit}
                      layout="vertical"
                      requiredMark={false}
                      className="space-y-2"
                      onValuesChange={handleInputChange}
                    >
                      <Form.Item
                        name="email"
                        label={
                          <span className="text-green-800 font-semibold text-lg">
                            User Name
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please input your username!",
                          },
                          {
                            pattern: /^[a-z0-9]*$/,
                            message:
                              "Only lowercase letters and 0-9 are allowed",
                          },
                        ]}
                      >
                        <Input
                          prefix={
                            <MailOutlined className="text-green-500 text-lg" />
                          }
                          placeholder="Enter your username"
                          size="large"
                          className="h-12 rounded-2xl border-2 border-green-200 focus:border-green-500 text-lg"
                        />
                      </Form.Item>

                      <Form.Item
                        name="password"
                        label={
                          <span className="text-green-800 font-semibold text-lg">
                            Password
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please input your password!",
                          },
                          {
                            pattern: /^[^\s]+$/,
                            message:
                              "Spaces are not allowed. Only 0-9 , special characters and alphabets are allowed",
                          },
                        ]}
                      >
                        <Input.Password
                          prefix={
                            <LockOutlined className="text-green-500 text-lg" />
                          }
                          placeholder="Enter your password"
                          size="large"
                          className="h-12 rounded-2xl border-2 border-green-200 focus:border-green-500 text-lg mb-4"
                        />
                      </Form.Item>

                      {/* <div className="flex items-center justify-between mb-4">
                        <Form.Item name="remember" valuePropName="checked" className="mb-0">
                          <Checkbox className="text-green-700">
                            <span className="text-green-700 font-medium text-lg">Remember me</span>
                          </Checkbox>
                        </Form.Item>
                        <span  onClick={handleForgetPasword} className=" hover: cursor-pointer
                         text-green-600 hover:text-green-800 transition-colors font-semibold text-lg">
                          Forgot password?
                        </span>
                      </div> */}

                      <Form.Item className="">
                        <Button
                          type="primary"
                          htmlType="submit"
                          loading={loading}
                          size="large"
                          block
                          className="h-12 text-xl font-bold bg-gradient-to-r from-green-500 to-emerald-600 border-0 rounded-2xl hover:from-green-600 hover:to-emerald-700 shadow-lg hover:shadow-xl transition-all duration-300"
                        >
                          {loading ? "Signing In..." : "Sign In to EMS"}
                        </Button>
                      </Form.Item>
                    </Form>
                  </div>
                </Card>
                {/* Value Proposition

                <div className="text-center mt-4">
                  <div className="inline-flex items-center space-x-3 px-6 py-3 bg-white/10 rounded-full backdrop-blur-lg">
                    <span className="text-green-500 font-semibold text-lg">🌱 Carbon Neutral Operations</span>
                  </div>
                  <p className="text-green-300 text-base mt-4 leading-relaxed">
                    Join thousands of organizations reducing their carbon footprint with intelligent energy management
                  </p>
                </div> */}
              </div>
            </Col>

            {/* Right Side - EMS Metrics & Features */}
            <Col
              xs={24}
              lg={12}
              className="bg-gradient-to-br from-green-600 to-emerald-700  items-center justify-center p-8 py-0 relative hidden md:flex"
              //            style={{
              //   backgroundImage: `url(${loginImg})`,
              //   backgroundSize: "contain",   // fills column while preserving aspect ratio
              //   backgroundPosition: "center",
              //   backgroundRepeat: "no-repeat",
              //   padding: "2rem",
              // }}
            >
              {/* <img
          src={expertLogo}
          alt="Background"
          className="object-contain w-full h-full"
        /> */}
              {/* Additional background effects for right side */}
              <div className="absolute inset-0 overflow-hidden">
                <div className="absolute top-10 left-10 w-20 h-20 bg-white/10 rounded-full floating blur-sm"></div>
                <div
                  className="absolute bottom-20 right-20 w-16 h-16 bg-white/10 rounded-lg floating-reverse blur-sm"
                  style={{ animationDelay: "3s" }}
                ></div>
                <div
                  className="absolute top-1/2 left-20 w-12 h-12 bg-white/10 rounded-full pulse-animation blur-sm"
                  style={{ animationDelay: "5s" }}
                ></div>
              </div>

              <div className="w-full max-w-lg text-white relative z-10">
                {/* Hero Section */}
                <div className="items-center flex justify-center w-full">
                  <img src={logo || expertLogo} className="h-20 w-20" />
                </div>
                <div className="text-center mb-0">
                  <h2 className="text-2xl font-bold mb-0">
                    Manage Energy, Maximize Efficiency
                  </h2>
                  <p className="text-green-100 text-lg">
                    Track, analyze, and optimize your energy usage in real time
                  </p>
                </div>

                {/* Real-time Metrics Dashboard */}
                <div
                  className={`${background ? "h-[40vh]" : ""} mb-0 `}
                  style={{
                    backgroundImage: `url(${background})`,
                    backgroundSize: "contain", // fills column while preserving aspect ratio
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    // padding: "2rem",
                  }}
                >
                  {!background && (
                    <Row gutter={[20, 20]}>
                      <Col span={12}>
                        <Card className="metric-card bg-white/10 border-0 backdrop-blur-lg count-up rounded-2xl">
                          <Statistic
                            title={
                              <span className="text-green-100 text-lg">
                                Energy Saved
                              </span>
                            }
                            value={metrics.energySaved}
                            suffix="kWh"
                            valueStyle={{
                              color: "#34d399",
                              fontSize: "28px",
                              fontWeight: "bold",
                            }}
                            prefix={<ThunderboltOutlined />}
                          />
                          <div className="mt-1">
                            <ReactECharts
                              option={miniChartOption}
                              style={{ height: "20px" }}
                            />
                          </div>
                        </Card>
                      </Col>
                      <Col span={12}>
                        <Card
                          className="metric-card bg-white/10 border-0 backdrop-blur-lg count-up rounded-2xl"
                          style={{ animationDelay: "0.2s" }}
                        >
                          <Statistic
                            title={
                              <span className="text-green-100 text-lg">
                                CO₂ Reduction
                              </span>
                            }
                            value={metrics.co2Reduction}
                            suffix="kg"
                            valueStyle={{
                              color: "#6ee7b7",
                              fontSize: "28px",
                              fontWeight: "bold",
                            }}
                            prefix={<EnvironmentOutlined />}
                          />
                          <Progress
                            percent={75}
                            showInfo={false}
                            strokeColor="#34d399"
                            trailColor="rgba(255,255,255,0.2)"
                            size="small"
                            className="mt-1"
                          />
                        </Card>
                      </Col>
                      <Col span={12}>
                        <Card
                          className="metric-card bg-white/10 border-0 backdrop-blur-lg count-up rounded-2xl"
                          style={{ animationDelay: "0.4s" }}
                        >
                          <Statistic
                            title={
                              <span className="text-green-100 text-lg">
                                Cost Savings
                              </span>
                            }
                            value={metrics.costSavings}
                            prefix="₹"
                            valueStyle={{
                              color: "#a7f3d0",
                              fontSize: "28px",
                              fontWeight: "bold",
                            }}
                          />
                          <div className="text-green-200 text-base mt-3">
                            <RiseOutlined /> This month
                          </div>
                        </Card>
                      </Col>
                      <Col span={12}>
                        <Card
                          className="metric-card bg-white/10 border-0 backdrop-blur-lg count-up rounded-2xl"
                          style={{ animationDelay: "0.6s" }}
                        >
                          <Statistic
                            title={
                              <span className="text-green-100 text-lg">
                                Efficiency
                              </span>
                            }
                            value={metrics.efficiency}
                            suffix="% ↑"
                            valueStyle={{
                              color: "#10b981",
                              fontSize: "28px",
                              fontWeight: "bold",
                            }}
                            prefix={<TrophyOutlined />}
                          />
                          <div className="text-green-200 text-base mt-3">
                            vs last month
                          </div>
                        </Card>
                      </Col>
                    </Row>
                  )}
                </div>

                {/* Automation Features Banner */}
                {/* <div className="animate-fade-in-up">
      <Card className="bg-white/10 border-0 backdrop-blur-lg rounded-3xl shadow-lg">
        <div className="text-center mb-6 animate-fade-in">
          <h3 className="text-2xl font-bold text-white mb-3">Automation Features</h3>
          <p className="text-green-100 text-lg">AI-powered energy optimization</p>
        </div>

        <div className="grid grid-cols-2 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`text-center p-4 bg-white/5 rounded-2xl transition-all duration-500 transform 
                          hover:bg-white/10 hover:scale-105 hover:-rotate-1 shadow-md 
                          animate-fade-in-delay-${index}`}
            >
              <div
                className="text-3xl mb-3 transition-transform duration-500 hover:scale-125"
              >
                {feature.icon}
              </div>
              <h4 className="font-semibold text-white text-base mb-2">
                {feature.title}
              </h4>
              <p className="text-green-200 text-sm">{feature.description}</p>
            </div>
          ))}
        </div>
      </Card>
    </div> */}

                {/* Value Proposition */}
                <div className="text-center mt-2">
                  <div className="inline-flex items-center space-x-3 px-6 py-3 bg-white/10 rounded-full backdrop-blur-lg">
                    <span className="text-green-300 font-semibold text-lg">
                      🌱 Carbon Neutral Operations
                    </span>
                  </div>
                  <p className="text-green-100 text-base mt-4 leading-relaxed">
                    Join thousands of organizations reducing their carbon
                    footprint with intelligent energy management
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        {/* <EmailPasswordReset visible={visible} onClose={onClose} /> */}
      </div>
    </>
  );
};

export default LoginForm2;
